module.exports = __webpack_public_path__ + "TruenoLt.5258bb6653ec14bcbaed.otf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/fonts/TruenoLt.otf
// module id = ../../../../../src/assets/fonts/TruenoLt.otf
// module chunks = styles